export default Vue => {
  Vue.component("v-select-basic", () => import("./v-select-basic.vue"));
};
